import { render, staticRenderFns } from "./PeriodicalPopView.vue?vue&type=template&id=e8f391d8&scoped=true"
import script from "./PeriodicalPopView.vue?vue&type=script&lang=js"
export * from "./PeriodicalPopView.vue?vue&type=script&lang=js"
import style0 from "./PeriodicalPopView.vue?vue&type=style&index=0&id=e8f391d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f391d8",
  null
  
)

export default component.exports